<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Casos"
                                type="gradient-red"
                                :sub-title="(indicadores.casosTotal === undefined) ? '' : String(indicadores.casosTotal.total)"
                                icon="fa fa-inbox"
                                class="mb-4 mb-xl-0">

                        <!--<template slot="footer">-->
                            <!--<span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>-->
                            <!--<span class="text-nowrap">Since last month</span>-->
                        <!--</template>-->
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Finalizados"
                                type="gradient-orange"
                                :sub-title="(indicadores.casosTotal === undefined) ? '' : String(indicadores.finalizado.total)"
                                icon="fa fa-check-circle"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> {{ (indicadores.casosTotal === undefined) ? '' : String(indicadores.finalizado.porcentaje) }}%</span>
                            <span class="text-nowrap">del total de casos.</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="En proceso"
                                type="gradient-green"
                                :sub-title="(indicadores.casosTotal === undefined) ? '' : String(indicadores.proceso.total)"
                                icon="fa fa-spinner"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> {{(indicadores.casosTotal === undefined) ? '' : String(indicadores.proceso.porcentaje) }}%</span>
                            <span class="text-nowrap">del total de casos.</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Mes Actual"
                                type="gradient-info"
                                :sub-title="(indicadores.casosTotal === undefined) ? '' : String(indicadores.casosMes.total)"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <!-- <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col text-right">
                                    <base-button type="primary" size="sm" @click="modalCrearCaso = true"><i class="fa fa-plus"></i> Crear</base-button>
                                    <modal :show.sync="modalCrearCaso" id="mCreateCase" gradient="danger" modal-classes="modal-danger modal-dialog-centered modalCreateCase" modalContentClasses="mContentCreateCase" bodyClasses="bg-white overflow-auto" data-backdrop="static">
                                        <h3 slot="header" class="modal-title"><i class="fas fa-file"></i> Nuevo Caso</h3>

                                        <div class="py-3 text-left">
                                            <crear ref="crearCaso" @event="cerrarModalCrearCaso"></crear>
                                        </div>

                                        <template slot="footer">
                                            <base-button type="link"
                                                         text-color="white"
                                                         class="ml-auto"
                                                         @click="cancelarCrearCaso">
                                                Cancelar
                                            </base-button>
                                            <base-button type="default" @click="submitCase">Crear</base-button>
                                        </template>
                                    </modal>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                           
                            <vue-good-table :columns="columns" :rows="allCasos"   :sort-options="sortOptions" styleClass="vgt-table striped ">
                            <!-- <vue-good-table :columns="columns" :rows="allCasos"  :pagination-options="paginationOptions" :sort-options="sortOptions" styleClass="vgt-table striped "> -->
                                <!-- <template>
                                    <base-input class="w-100" alternative="" v-model="filtroBuscar" @keyup="buscar" input-classes="form-control-alternative input-custom" />
                                </template> -->
                                <template slot="table-actions">
                                     <div class="d-flex flex-row " style="height: 43px;">
                                        <base-input class="w-100" alternative="" v-model="filtroBuscar" @keyup="buscar" input-classes="form-control-alternative input-custom" />
                                        <base-button type="white" size="sm" icon="fas fa-sync-alt" @click="getAll(true)"></base-button>     
                                    </div>
                                </template>
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'sla'">
                                        <span class="p-1 rounded text-white" :class="{'bg-success': getSLA(props.column) === 1, 'bg-warning': getSLA(props.column) === 2, 'bg-danger': getSLA(props.column) === 3}">SLA</span>
                                    </span>
                                    <span v-if="props.column.field == 'actions'">
                                        <div v-if="reabrircaso.value === 'SI'">
                                            <base-button v-if="getFinalizado(props.row) == true && limitReabrir(props.row) == true" icon="fas fa-envelope-open" size="sm" type="warning"  @click="reabrirCasoBtn(props.row)"></base-button>
                                        </div> 
                                    </span>
                                    <span v-if="props.column.field == 'refnum'" class="d-flex">
                                        <a @click="getViewLink(props.row.id)" class="linkRefnum">{{ props.row.refnum }}</a>
                                        <span v-if="casoReabierto(props.row) == true" class="ml-2"><i class="fas fa-undo-alt"></i></span>
                                    </span>
                                    
                                    <span v-else>
                                      {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                            <!-- <base-pagination :page-count="cantidadPaginasC"></base-pagination> -->
                            <pagination  type="casos" :paginas="cantidadPaginasC.paginas" :cantidad="cantidadPaginasC.cantidad" :filtro="filtroBuscar"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '~vue-good-table/dist/vue-good-table.css';

    .vgt-global-search {
        border: 0 !important;
        background: none !important;
        .vgt-global-search__actions {
            width: 50%;
        }


        .vgt-global-search__input {
            @apply p-0;

            .input__icon {
                position: absolute;
                top: 0;
                right: 15px;
                max-width: 32px;
                left: inherit;
            }

            .vgt-pull-left {
                float: right !important;
            }

            .vgt-input {
                width: 50%;
                background-color: #fff;
                border: 0;
                border-bottom: 1px solid #eaeaea!important;
                border-radius: 0;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #565656;
                height: 30px;
                max-width: 100%;
                padding: 7px 40px 7px 10px;
                -webkit-transition: all 300ms linear 0s;
                transition: all 300ms linear 0s;

                &:focus {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    border-color: #b7b7b7;
                }

                @screen sm {
                    width: 70%;
                }
                @screen lg {
                    width: 40%;
                }
            }
        }
    }

    .vgt-table {
        border: 0 !important;
        font-size: 14px !important;

        &.striped tbody tr:nth-of-type(odd) {
            @apply bg-grey-lightest;
        }

        thead th {
            @apply border-b bg-grey-light;
            background: none !important;
        }

        tbody td {
            vertical-align: middle !important;
            border-bottom: 0 !important;
        }
    }

    .vgt-wrap__actions-footer {
        @apply border-0 border-b bg-grey-light;
    }

    .vgt-wrap__footer {
        border: 0 !important;
        background: none !important;
    }

    .linkRefnum {
        text-decoration: underline!important;
        cursor: pointer!important;
    }

    .linkRefnum:hover {
        opacity: .6;
    }

    .modalCreateCase {
        max-width: 68%!important;

        .mContentCreateCase {
            height: 580px;
        }
    }
</style>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import { VueGoodTable } from 'vue-good-table'
    import Crear from './Crear'
    import pagination from './Pagintacion'
    import BasePagination from '../../components/BasePagination.vue'

    export default {
        name: "Casos",
        components: {
            VueGoodTable,
            Crear,
            pagination,
            BasePagination
        },
        props: {
            query: {
                type: Object,
                required: false,
                default: () => ({})
            }
        },
        data() {
          return {
                valuePagination: {
                    default: 1
                },
                selectedPageC: 1,
                rowsOnPageC: 10,
                filtroBuscar: '',
                modalCrearCaso: false,
                datosCase: '',
                columns: [{
                        label: 'N°',
                        field: 'refnum',
                        thClass: 'centrarColumn',
                        width: '100px',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Asunto',
                        field: 'asunto',
                        thClass: 'centrarColumn'
                    }, {
                        label: 'Fecha',
                        field: 'fechacreacion',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'DD-MM-YYYY',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Tipo',
                        field: 'idtipodesc',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Estado',
                        field: 'idestadodesc',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Canal',
                        field: 'origen',
                        thClass: 'centrarColumn',
                        tdClass: 'vgt-center-align'
                    }, {
                        label: 'Reabrir',
                        field: 'actions',
                        sortable: false,
                        thClass: 'centrarColumn',
                        width: '90px',
                        tdClass: 'vgt-center-align'
                    }
                ],
                sortOptions: {
                    enabled: true,
                    initialSortBy: { field: 'refnum', type: 'desc'}
                },
                searchOptions: {
                    enabled: true,
                    placeholder: 'Buscar'
                },
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPage: 10,
                    position: 'bottom',
                    perPageDropdown: [10, 25, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'Siguiente',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Registros por pág.',
                    ofLabel: 'de',
                    pageLabel: 'pág.',
                    allLabel: 'Todos'
                }
          }
        },
        watch: {
            modalCrearCaso: function(val) {
                if (val) {
                }
            }
        },
        computed: {
            ...mapGetters('casos',{ allCasos: 'all', indicadores: 'indicadores', pagination: 'paginationCasos'}),
            ...mapGetters('parametros', { allParametros: 'all' }),
            cantidadPaginasC(){
                let calculoPaginasC = Math.ceil(this.pagination.size / this.rowsOnPageC)
                let cantidadPaginas = []
                for (let i=1; i<=calculoPaginasC;i++) {
                    cantidadPaginas.push(i)
                }
                return {
                    paginas: cantidadPaginas,
                    cantidad: calculoPaginasC
                }
            },
            reabrircaso() {
                return this.allParametros.data.find(item => item.key === 'REABRIR_CASO') || {}
            },
            tiemporeabrircaso() {
                return this.allParametros.data.find(item => item.key === 'TIEMPO_REABRIR_CASO') || {}
            }
        },
        methods: {
            ...mapActions('casos',{ getAllCasos: 'getAll', getIndicador: 'getIndicadores' }),
            ...mapActions('parametros', { getAllParametros: 'getAll' }),
            getAll(){
                Promise.all([
                    this.getAllParametros({ parametro: 1 }),
                    this.getAllCasos({
                        pagina: 1,
                        cantidad: 10
                    })
                ]).then(() => {
                    this.getIndicador(this.allCasos)
                    this.columnReabrir()
                })
            },
            columnReabrir(){
                let reabrir = this.columns.findIndex(item => item.label === 'Reabrir')
                   if (this.reabrircaso.value === 'NO' && this.columns.length > 6){
                       this.columns.splice(reabrir, 1)
                   }
                   if (this.reabrircaso.value === 'SI' && this.columns.length < 7 ) {
                       this.columns.push({
                            label: 'Reabrir',
                            field: 'actions',
                            sortable: false,
                            tdClass: 'vgt-center-align'
                       })
                   }
            },
            getFinalizado(item) {
                if (item.finalizado === 1) {
                    return true
                }else {
                    return false
                }
            },

            limitReabrir(item){
                /**
                 * la fecha de finalizacion es la fecha en que finalizo el caso mas la hora limite para poder reabrir
                 * en caso que no tenga fecha de finalizacion tomara por defecto fechamodificacionhoralimit que vendria siendo la 
                 * ultima fecha que se modifico el caso
                 */
                let fechaLimite = item.fechafinalizacionhoralimit ?  Date.parse(item.fechafinalizacionhoralimit) : Date.parse(item.fechamodificacionhoralimit)
                let ahora = new Date().getTime()
                
                if (fechaLimite < ahora ) {
                    return false
                } else {
                    return true
                }
                
            },
            casoReabierto(item){
                if (item.fechareapertura != null){
                    return true
                }
            },
            reabrirCasoBtn(item) {
                this.$store.dispatch('casos/custom', { method: 'put', endpoint: 'casos/reopencase', dataToSend: { id: item.id } })
                .then((data) => {
                    let params = Object.assign({}, { force: true }, this.query || {})
                    this.$store.dispatch(`casos/getAll`, params)
                    .then(() => {
                        this.$router.push({ name: 'detalle caso', params: { id: data.data.id }})
                        this.$notify({
                            group: 'foo',
                            title: 'Mensaje',
                            type: 'success',
                            speed: 1000,
                            duration: 500,
                            text: 'Caso reabierto exitosamente.'
                        });
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            title: 'Mensaje',
                            type: 'error',
                            speed: 1000,
                            duration: 500,
                            text: 'No se ha podido reabrir este caso.'
                        });
                    })
                })
            },
            getViewLink(id) {
                this.$router.push({ name: 'detalle caso', params: { id: id }})
            },
            getSLA(item) {
                let sla = item.sla > 0 ? (item.timeactual / item.sla) : 0
                if (sla >= 1) {
                    return 3
                }
                if (sla >= 0.75) {
                    return 2
                }
                if (sla < 0.75) {
                    return 1
                }
            },
            submitCase() {
                this.$refs.crearCaso.save()
            },
            cerrarModalCrearCaso() {
                this.modalCrearCaso = false
                this.getAll(true)
            },
            cancelarCrearCaso() {
                this.$refs.crearCaso.resetearCrearCaso()
                this.modalCrearCaso = false
                this.getAll(true)
            },
            buscar(entrada) {
                
                let params;
                if ((entrada.target.value !== null || entrada.target.value !== '') && entrada.target.value.length > 2) {
                    params = Object.assign({},  { pagina: 1, cantidad: 10, filtrobuscar: entrada.target.value } )
                    this.getAllCasos(params)
                } else if (entrada.target.value.length === 0) {
                    params = Object.assign({},  { pagina: 1, cantidad: 10 } )
                    this.getAllCasos(params)
                }
            },
        },
        mounted() {
            this.getAll(true)
        }
    }
</script>